import { render, staticRenderFns } from "./RoleListTable.vue?vue&type=template&id=107db61c&scoped=true&"
import script from "./RoleListTable.vue?vue&type=script&lang=js&"
export * from "./RoleListTable.vue?vue&type=script&lang=js&"
import style0 from "./RoleListTable.vue?vue&type=style&index=0&id=107db61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107db61c",
  null
  
)

export default component.exports